export const RIGHT_TYPES = [
  "access",
  "rectification",
  "erasure",
  "objection",
  "portability",
  "restriction",
];

export const POPULATION_CATEGORIES = [
  "employee",
  "candidate",
  "customer",
  "prospect",
  "visitor",
  "supplier",
  "advisor",
  "governance",
  "whistleblowing",
  "other",
];

const translations = {
  fr: {
    langName: "Français",
    // header
    portalTitle: "Exercice des droits RGPD",
    portalSubtitle: "Formulaire officiel de demande d'exercice de vos droits",
    securedBadge: "Transmission chiffrée TLS 256 bits",
    compliantBadge: "Conforme RGPD",
    skipToContent: "Aller au contenu principal",
    // rights
    rights: {
      access: "Droit d'accès",
      rectification: "Droit de rectification",
      erasure: "Droit à l'effacement",
      objection: "Droit d'opposition",
      portability: "Droit à la portabilité",
      restriction: "Limitation du traitement",
    },
    rightsHelp: {
      access: "Obtenir une copie des données personnelles vous concernant.",
      rectification: "Corriger des données inexactes ou incomplètes.",
      erasure: "Demander la suppression de vos données personnelles.",
      objection: "Vous opposer au traitement de vos données.",
      portability: "Récupérer vos données dans un format réutilisable.",
      restriction: "Limiter temporairement l'usage de vos données.",
    },
    rightsDetail: {
      access:
        "Savoir si l'organisation traite des données vous concernant et en obtenir une copie, avec les finalités du traitement, les destinataires, la durée de conservation et l'origine des données (art. 15 RGPD).",
      rectification:
        "Faire corriger ou compléter des informations inexactes ou incomplètes vous concernant : nom, adresse, coordonnées… (art. 16 RGPD).",
      erasure:
        "Obtenir la suppression de vos données, notamment si elles ne sont plus nécessaires, si vous retirez votre consentement ou si leur traitement est illicite. Une obligation légale peut toutefois imposer leur conservation (art. 17 RGPD).",
      objection:
        "Vous opposer à tout moment à l'utilisation de vos données à des fins de prospection, ou, pour des raisons tenant à votre situation particulière, à un traitement fondé sur l'intérêt légitime de l'organisation (art. 21 RGPD).",
      portability:
        "Recevoir les données que vous avez fournies dans un format structuré et lisible par machine (CSV, JSON…), pour les conserver ou les transmettre à un autre organisme. S'applique aux traitements fondés sur votre consentement ou un contrat (art. 20 RGPD).",
      restriction:
        "Geler temporairement l'utilisation de vos données : elles sont conservées mais plus exploitées, par exemple le temps de vérifier leur exactitude ou d'examiner votre opposition (art. 18 RGPD).",
    },
    rightMoreInfo: "En savoir plus :",
    // populations
    populations: {
      employee: "Je suis (ou j'ai été) salarié, stagiaire, alternant ou intérimaire",
      candidate: "J'ai postulé à une offre d'emploi ou de stage",
      customer: "Je suis client, usager, adhérent ou patient",
      prospect: "J'ai été contacté commercialement ou je reçois la newsletter",
      visitor: "J'ai visité le site internet, les réseaux sociaux ou les locaux",
      supplier: "Je travaille pour un fournisseur, prestataire ou partenaire",
      advisor: "J'interviens comme conseil ou professionnel réglementé",
      governance: "Je suis dirigeant, associé, actionnaire ou représentant légal",
      whistleblowing: "Je suis concerné par une procédure d'alerte",
      other: "Autre situation",
    },
    populationsHelp: {
      employee:
        "Personnes travaillant ou ayant travaillé au sein de l'organisme, y compris les représentants du personnel.",
      candidate: "Candidatures spontanées ou en réponse à une offre, retenues ou non.",
      customer:
        "Personnes bénéficiant des produits ou services de l'organisme, y compris les utilisateurs de la plateforme.",
      prospect: "Prospects et abonnés aux communications marketing.",
      visitor: "Visiteurs physiques ou en ligne, abonnés aux réseaux sociaux, auteurs de contenus publiés.",
      supplier:
        "Contacts chez les fournisseurs, sous-traitants, partenaires, assureurs et co-contractants, actuels ou potentiels.",
      advisor: "Avocats, experts-comptables, commissaires aux comptes, greffiers, médecin du travail.",
      governance: "Personnes intervenant dans la gouvernance ou le capital de l'organisme.",
      whistleblowing: "Auteur d'un signalement (lanceur d'alerte) ou personne visée par celui-ci.",
      other: "Aucune des situations ci-dessus.",
    },
    populationHint: "Cochez une ou plusieurs situations qui vous correspondent.",
    populationRequired: "Sélectionnez au moins une situation.",
    // form
    stepRight: "1. Nature de la demande",
    stepPopulation: "2. Votre situation vis-à-vis de l'organisme",
    stepIdentity: "3. Identification du demandeur",
    stepDetails: "4. Détails de la demande",
    stepConsent: "5. Consentement",
    lastName: "Nom",
    firstName: "Prénom",
    email: "Adresse e-mail",
    verificationType: "Type de vérification d'identité",
    verifCard: "Pièce d'identité jointe",
    verifAccount: "Correspondance avec mon compte",
    message: "Message / précisions",
    messagePlaceholder: "Décrivez précisément votre demande…",
    attachments: "Pièces jointes (facultatif)",
    attachmentsHelp: "PDF, PNG, JPEG, WEBP — max 3 fichiers, 5 Mo chacun.",
    dropzone: "Glissez vos fichiers ici ou",
    browse: "parcourir",
    remove: "Retirer",
    consentLabel:
      "Je certifie être la personne concernée (ou son représentant habilité) et j'autorise le traitement de cette demande.",
    submit: "Envoyer ma demande",
    submitting: "Transmission sécurisée en cours…",
    // errors
    required: "Ce champ est obligatoire.",
    nameTooLong: "100 caractères maximum.",
    invalidEmail: "Adresse e-mail invalide.",
    consentRequired: "Vous devez accepter pour continuer.",
    fileTooBig: "Fichier trop volumineux (max 5 Mo).",
    fileType: "Type de fichier non autorisé.",
    tooManyFiles: "3 fichiers maximum.",
    genericError: "Une erreur est survenue. Merci de réessayer.",
    // confirmation
    confirmTitle: "Demande enregistrée",
    confirmText:
      "Votre demande a bien été prise en charge et transmise de façon sécurisée. Conservez la référence ci-dessous.",
    referenceLabel: "Référence de suivi",
    confirmEmailSent: "Un e-mail de confirmation reprenant cette référence vous a été envoyé.",
    statusReceived: "Reçue",
    statusTransmitted: "Transmise au service",
    statusQueued: "En file d'attente (nouvel essai automatique)",
    statusProcessing: "En cours de traitement",
    newRequest: "Nouvelle demande",
    // unavailable
    unavailableTitle: "Formulaire indisponible",
    unavailableText:
      "Cette configuration n'existe pas ou n'est pas publiée. Vérifiez le lien fourni par l'organisation.",
    domainBlockedTitle: "Domaine non autorisé",
    domainBlockedText:
      "Ce site n'est pas autorisé à intégrer ce formulaire. Contactez l'organisation qui vous a fourni ce lien.",
    poweredBy: "Passerelle RGPD sécurisée",
  },
  en: {
    langName: "English",
    portalTitle: "GDPR Rights Request",
    portalSubtitle: "Official form to exercise your data protection rights",
    securedBadge: "256-bit TLS encrypted transmission",
    compliantBadge: "GDPR compliant",
    skipToContent: "Skip to main content",
    rights: {
      access: "Right of access",
      rectification: "Right to rectification",
      erasure: "Right to erasure",
      objection: "Right to object",
      portability: "Right to portability",
      restriction: "Restriction of processing",
    },
    rightsHelp: {
      access: "Obtain a copy of the personal data we hold about you.",
      rectification: "Correct inaccurate or incomplete data.",
      erasure: "Request deletion of your personal data.",
      objection: "Object to the processing of your data.",
      portability: "Receive your data in a reusable format.",
      restriction: "Temporarily restrict the use of your data.",
    },
    rightsDetail: {
      access:
        "Find out whether the organisation processes data about you and obtain a copy, along with the purposes of the processing, the recipients, the retention period and the source of the data (Art. 15 GDPR).",
      rectification:
        "Have inaccurate or incomplete information about you corrected or completed: name, address, contact details… (Art. 16 GDPR).",
      erasure:
        "Have your data deleted, in particular when it is no longer needed, when you withdraw your consent or when its processing is unlawful. A legal obligation may however require it to be kept (Art. 17 GDPR).",
      objection:
        "Object at any time to the use of your data for direct marketing, or, on grounds relating to your particular situation, to processing based on the organisation's legitimate interest (Art. 21 GDPR).",
      portability:
        "Receive the data you provided in a structured, machine-readable format (CSV, JSON…), to keep it or pass it on to another organisation. Applies to processing based on your consent or a contract (Art. 20 GDPR).",
      restriction:
        "Temporarily freeze the use of your data: it is kept but no longer used, for instance while its accuracy is checked or your objection is examined (Art. 18 GDPR).",
    },
    rightMoreInfo: "Learn more:",
    populations: {
      employee: "I am (or was) an employee, intern, apprentice or temporary worker",
      candidate: "I applied for a job or internship",
      customer: "I am a customer, user, member or patient",
      prospect: "I was contacted for marketing purposes or I receive the newsletter",
      visitor: "I visited the website, social media pages or premises",
      supplier: "I work for a supplier, service provider or partner",
      advisor: "I act as an adviser or regulated professional",
      governance: "I am a director, partner, shareholder or legal representative",
      whistleblowing: "I am involved in a whistleblowing procedure",
      other: "Other situation",
    },
    populationsHelp: {
      employee: "People who work or have worked for the organisation, including staff representatives.",
      candidate: "Unsolicited applications or applications to a job offer, whether successful or not.",
      customer: "People who use the organisation's products or services, including platform users.",
      prospect: "Prospects and subscribers to marketing communications.",
      visitor: "On-site or online visitors, social media followers, authors of published content.",
      supplier: "Contacts at suppliers, subcontractors, partners, insurers and co-contractors, current or prospective.",
      advisor: "Lawyers, chartered accountants, statutory auditors, court clerks, occupational physicians.",
      governance: "People involved in the governance or capital of the organisation.",
      whistleblowing: "Author of a report (whistleblower) or person targeted by it.",
      other: "None of the situations above.",
    },
    populationHint: "Select one or more situations that apply to you.",
    populationRequired: "Select at least one situation.",
    stepRight: "1. Nature of the request",
    stepPopulation: "2. Your relationship with the organisation",
    stepIdentity: "3. Requester identification",
    stepDetails: "4. Request details",
    stepConsent: "5. Consent",
    lastName: "Last name",
    firstName: "First name",
    email: "Email address",
    verificationType: "Identity verification type",
    verifCard: "Identity document attached",
    verifAccount: "Match with my account",
    message: "Message / details",
    messagePlaceholder: "Describe your request precisely…",
    attachments: "Attachments (optional)",
    attachmentsHelp: "PDF, PNG, JPEG, WEBP — max 3 files, 5 MB each.",
    dropzone: "Drag your files here or",
    browse: "browse",
    remove: "Remove",
    consentLabel:
      "I certify that I am the data subject (or an authorised representative) and I authorise the processing of this request.",
    submit: "Submit my request",
    submitting: "Secure transmission in progress…",
    required: "This field is required.",
    nameTooLong: "Maximum 100 characters.",
    invalidEmail: "Invalid email address.",
    consentRequired: "You must accept to continue.",
    fileTooBig: "File too large (max 5 MB).",
    fileType: "File type not allowed.",
    tooManyFiles: "Maximum 3 files.",
    genericError: "Something went wrong. Please try again.",
    confirmTitle: "Request registered",
    confirmText:
      "Your request has been received and securely transmitted. Keep the reference below for tracking.",
    referenceLabel: "Tracking reference",
    confirmEmailSent: "A confirmation email with this reference has been sent to you.",
    statusReceived: "Received",
    statusTransmitted: "Transmitted to service",
    statusQueued: "Queued (automatic retry)",
    statusProcessing: "Processing",
    newRequest: "New request",
    unavailableTitle: "Form unavailable",
    unavailableText:
      "This configuration does not exist or is not published. Please check the link provided by the organisation.",
    domainBlockedTitle: "Domain not authorised",
    domainBlockedText:
      "This site is not allowed to embed this form. Please contact the organisation that provided this link.",
    poweredBy: "Secure GDPR gateway",
  },
};

export function getDict(lang) {
  return translations[lang] || translations.fr;
}
